import React, { useEffect, useState } from "react";
import CrmEmpty from "../CrmEmpty";
import { Spin, Table, Space, Button, Input, Pagination } from 'antd';
import moment from 'moment-jalaali';
import CrmTicketInfoReport from "./CrmTicketInfoReport";
import strings from '../../../../utils/strings';
import { SearchOutlined, ZoomInOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { useGeneralStore } from "../../../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../../../store/slices/createReportsSlice";

export default function CrmTicketReport({ usrUserID, pageSize, category }) {

  const general = useGeneralStore();
  const reports = useReportsStore()
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const ticketDetails = reports.crmTicketReport.data.Items;
  const total = reports.crmTicketReport.data.Total;
  const loading = reports.crmTicketReport.loading;
  const visible = general.view.crmReportModal;
  const [page, setPage] = useState(1);





  const pageChange = (page, pageSize) => {


    setPage(page)
    reports.getCrmTicketReport({
      usrUserID: usrUserID,
      PageSize: pageSize,
      PageNumber: page
    });


  }


  useEffect(() => {
    setPage(1)

    if (usrUserID || category === "Ticket" || visible) {
      setPage(1)
    }
  }, [usrUserID, category, visible])


  let searchInput;
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node;
          }}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<ZoomInOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            ریست
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns = [
    {
      title: "جزئیات تيكت",
      dataIndex: "operation",
      key: "operation",
      width: 20,
      render: (_, ticket) =>
        ticketDetails.length >= 1 && (
          <Space size="middle">
            <Button
              type="link"
              onClick={() => {
                reports.getCrmTicketInfoReport(ticket.ID);
                general.ToggleCrmTicketInfoReportModal(true);
              }} size="small" ><ZoomInOutlined />
            </Button>
          </Space>
        )
    },
    {
      title: "شناسه",
      dataIndex: "ID",
      key: "ID",
      width: 40,
      ...getColumnSearchProps('ID', 'شناسه'),
    },
    {
      title: "وضعیت",
      dataIndex: "StatusTitle",
      key: "StatusTitle",
      width: 50,
    },
    {
      title: "نوع تماس",
      dataIndex: "ContactType",
      width: 50,
      key: "ContactType",
      render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
    },
    {
      title: "تاریخ ثبت",
      dataIndex: "CreationTime",
      key: "CreationTime",
      width: 80,
      render: data => strings.getFarsiNum(moment(data).format(" jYYYY/jMM/jDD  ساعت:  HH:mm  "))
    },
    {
      title: "دسته بندی",
      dataIndex: "ContactUsType",
      key: "ContactUsType",
      width: 140,
    },


  ];


  return (
    <div>
      <CrmTicketInfoReport />
      <Spin spinning={loading}>
        {ticketDetails && ticketDetails.length > 0 ? <>
          <Table
            style={{ overflowX: 'scroll' }}
            size="small"
            className="custom-table crm-request-report"
            bordered
            loading={loading}
            rowKey="ID"
            scroll={true}
            dataSource={ticketDetails}
            columns={columns}
            pagination={false}
          />
          <Pagination
            defaultCurrent={1}
            current={page}
            onChange={pageChange}
            pageSize={pageSize}
            total={total}
            showSizeChanger={false} />
        </>
          : <CrmEmpty text="تیکت یافت نشد" />}
      </Spin>
    </div>
  )
}